import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        approvalCode: null,
        event: null,
        eventId: null,
        events: [],
        products: [],
        timeline: [],
        trialData: [],
        productNames: [],
        diseaseStates: [],
        phases: [],
        localStorageProducts: [],
        localStorageDisclaimer: false,
        disclaimerShown: false,
        reusableDisclaimerShown: {},
        disclaimerContent: '',
        hasIndexRedirect: false,
        approval: [],
        productSearch: [],
        trialSearch: [],
        searchValue: '',
        trialImages: [],
    },
    getters: {
        getEventId: state => {
            let eventId = state.eventId || window.localStorage.getItem('appEventId');
            if (!eventId) {
                const event = state.events.filter(event => {
                    return event.field_event_is_live_
                        && event.field_event_is_live_.length > 0
                        && event.field_event_is_live_[0].value === 'Yes';
                }).shift();

                if (event) {
                    eventId = event.tid[0].value;
                }
            }
            return eventId;
        },
        getEvent: (state, getters) => {
            return state.events.filter(event => parseInt(event.tid[0].value, 10) === parseInt(getters.getEventId, 10)).shift()
        },
        getEventApprovalCode: (state, getters) => {
            const event = getters.getEvent;
            return event ? event.field_app_shell_approval_code[0].value : '';
        },
        getEventDisclaimer: (state, getters) => {
            const event = getters.getEvent;
            return event ? event.field_homepage_disclaimer[0].value : '';
        },
        getEvents: state => state.events,
        getProductSearch: state => state.productSearch,
        getTrialSearch: state => state.trialSearch,
        allProducts: (state, getters) =>  state.products.filter((product) => {
            return product.field_eventtrial && product.field_eventtrial.length && getters.getEventId
                && parseInt(product.field_eventtrial[0].target_id, 10) === parseInt(getters.getEventId, 10);
        }),
        allTimeline: state => state.timeline,
        getTrialData: state => state.trialData,
        getProductNames: state => state.productNames,
        getDiseaseStates: state => state.diseaseStates,
        getPhases: state => state.phases,
        getLocalStorageProducts: state => state.localStorageProducts,
        getLocalStorageDisclaimer: state => state.localStorageDisclaimer,
        getDisclaimerStatus: state => state.disclaimerShown,
        getReusableDisclaimerStatus: state => state.reusableDisclaimerShown,
        getIndexRedirect: state => state.hasIndexRedirect,
        getDisclaimerContent: (state, getters) => state.disclaimerContent.filter((content) => {
            return content.field_event && content.field_event.length && content.field_event[0].target_id && getters.getEventId &&
                parseInt(content.field_event[0].target_id, 10) === parseInt(getters.getEventId, 10);
        }).shift(),
        // getApproval: state => state.approval,
        getApproval: (state, getters) => state.approval.filter((approval) => {
            return approval.field_eventapproval && approval.field_eventapproval.length && 
                   approval.field_eventapproval[0].target_id && getters.getEventId &&
                   parseInt(approval.field_eventapproval[0].target_id, 10) === parseInt(getters.getEventId, 10);
        }).shift(),
        getApprovalCode: getters => getters.approvalCode,
        getSearchTerm: state => state.searchValue,
        getTrialImages: state => state.trialImages,
        getAllowedDiseaseStates: (state, getters) => {
            var trials = getters.allProducts;
            var notAllowedItems = window.localStorage.getItem('storageProducts');
            let allowedStates = [];

            let diseaseStates = [];
            if (notAllowedItems !== null) {
                var notAllowed = JSON.parse(notAllowedItems);
                let filtered = trials.filter( el => el.field_product_list && notAllowed.indexOf(el.field_product_list[0].target_id) < 0 );

                let pillars = [];

                if (filtered.length > 0) {
                    filtered.forEach(function (filt) {
                        let ds = filt.field_disease_state_tag;
                        let dsLength = ds.length;
                        for (let i = 0; i<dsLength; i++) {
                            pillars.push(ds[i].target_id);
                        }
                    });9
                }

                const distinct = (value, index, self) => {
                    return self.indexOf(value) === index;
                };

                allowedStates = pillars.filter(distinct);
                diseaseStates = state.diseaseStates.filter( el => allowedStates.indexOf(el.tid[0].value.toString()) > -1);
            } else {
                diseaseStates = getters.getDiseaseStates;
            }

            const items = getters.allProducts.map(product => parseInt(product.field_disease_state_tag[0].target_id, 10));

            return diseaseStates.filter((diseaseStates) => {
                return items.indexOf(diseaseStates.tid[0].value) > -1
            });
        },
        getAllowedProducts: (state, getters) => {
            let products = getters.getProductNames;

            return products.filter((product) => {
                var notAllowedItems = window.localStorage.getItem('storageProducts');

                if (product && notAllowedItems !== null) {
                    var notAllowed = JSON.parse(notAllowedItems);
                    let idIsString = product.nid[0].value.toString();

                    if (notAllowed.indexOf(idIsString) > -1) {
                        return false;
                    }
                }

                return getters.allProducts.filter((p) => {
                    return p.field_product_list.filter((item) => {
                        return parseInt(item.target_id, 10) === parseInt(product.nid[0].value, 10);
                    }).length > 0;
                }).length > 0;
            });
        }
    }, 
    mutations: {
        SET_DEFAULT_APPROVAL_CODE(state, getters) {
            const approval = getters.getApproval;
            let approvalCode = '';
            if (approval && approval.field_overall_approval_number.length > 0) {
                approvalCode = approval.field_overall_approval_number[0].value;
            }
            state.approvalCode = approvalCode;
        },
        SET_APPROVAL_CODE(state, approvalCode) {state.approvalCode = approvalCode},
        SET_EVENT_ID(state, eventId) {
            state.eventId = eventId;
            if (eventId) {
                window.localStorage.setItem('appEventId', eventId);
            } else {
                window.localStorage.removeItem('appEventId');
            }
        },
        SET_EVENTS(state, events) {state.events = events},
        SET_PAGE_DATA(state, information) {state.products = information},
        SET_ROW_DATA(state, row) {state.trialData = row},
        CLEAR_ROW_DATA(state) {state.trialData = []},
        SET_PRODUCT_NAMES(state, names) {state.productNames = names },
        SET_DISEASE_STATES(state, diseases) {state.diseaseStates = diseases},
        SET_PHASES(state, phase) {state.phases = phase },
        SET_LOCAL_STORAGE_PRODUCTS(state, products) {state.localStorageProducts = products},
        SET_LOCAL_STORAGE_DISCLAIMER(state, disclaimer) {state.localStorageDisclaimer = disclaimer},
        SET_DISCLAIMER_SHOWN(state) {state.disclaimerShown = true},
        SET_REUSABLE_DISCLAIMER_SHOWN(state, id) {state.reusableDisclaimerShown[id] = true},
        STORE_REUSABLE_DISCLAIMER_STATES(state) {
            const states = JSON.stringify(state.reusableDisclaimerShown);
            window.sessionStorage.setItem('reusableDisclaimerStates', states);
        },
        CLEAR_DISCLAIMER_SHOWN(state) {state.disclaimerShown = false},
        SET_DISCLAIMER_CONTENT(state, disclaimerContent) {state.disclaimerContent = disclaimerContent },
        SET_INDEX_REDIRECT(state) {state.hasIndexRedirect = true},
        SET_APPROVAL(state, data) {state.approval = data},
        SET_PRODUCT_SEARCH(state, data) {state.productSearch = data},
        SET_TRIAL_SEARCH(state, data) {state.trialSearch = data},
        SET_SEARCH_TERM(state, term) {state.searchValue = term},
        RESET_SEARCH_RESULTS(state) {
            state.productSearch = [];
            state.trialSearch = [];
            state.searchValue = '';
        },
        SET_TRIAL_LOGOS(state, data) {
            state.trialImages = data;
        }
    },
    actions: {
        setDefaultApprovalCode(context) {
            context.commit('SET_APPROVAL_CODE');
        },
        setApprovalCode(context, approvalCode) {
            context.commit('SET_APPROVAL_CODE', approvalCode);
        },
        setEventId(context, eventId) {
            context.commit('SET_EVENT_ID', eventId);
        },
        removeSearchResults(context){
            context.commit('RESET_SEARCH_RESULTS');
        },
        setSearchTerm(context, term){
            context.commit('SET_SEARCH_TERM', term);
        },
        setTrialSearchResults(context, data) {
            context.commit('SET_TRIAL_SEARCH', data);
        },
        setProductSearchResults(context, data) {
            context.commit('SET_PRODUCT_SEARCH', data);
        },
        setIndexRedirect(context) {
            context.commit('SET_INDEX_REDIRECT'); 
        },
        setDisclaimerStatus: function(context) {
            context.commit('SET_DISCLAIMER_SHOWN'); 
        },
        setReusableDisclaimerStatus: function(context, payload) {
            context.commit('SET_REUSABLE_DISCLAIMER_SHOWN', payload.id);
        },
        storeReusableDisclaimerStatus: function(context) {
            context.commit('STORE_REUSABLE_DISCLAIMER_STATES');
        },
        clearDisclaimerStatus: function(context) {
            context.commit('CLEAR_DISCLAIMER_SHOWN');
        },
        setDisclaimerContent: function(context) {
            context.commit('SET_DISCLAIMER_CONTENT', window.disclaimers);
        },
        setPageData: function(context/*, mainJson*/){
            context.commit('SET_PAGE_DATA', window.nodes); 
        },
        setSpecificRow: function(context, routeId) {
            let p = this.state.products; 
            
            for(var item in p){
                if( p[item].nid[0].value == routeId)
                {
                    context.commit('SET_ROW_DATA', p[item]); 
                }
            }
        },
        clearRowData: function(context) {
            context.commit('CLEAR_ROW_DATA');
        },
        setProductNames: function(context/*, productNames*/) {
            context.commit('SET_PRODUCT_NAMES', window.products); 
        },
        setDiseaseStates: function(context/*, diseaseStates*/) {
            let states = window.disease_states;
            // let filtered = states.filter(el => el.name[0].value !== 'DKD');
            context.commit('SET_DISEASE_STATES', states);
        },
        setPhases: function(context/*, phases*/) {
            context.commit('SET_PHASES', window.phases); 
        },
        setEvents: function(context/*, phases*/) {
            context.commit('SET_EVENTS', window.events);
        },
        setApproval: function(context) {
            context.commit('SET_APPROVAL', window.approval);
        },
        storeTrialLogos: function(context/*, images*/) {
            let nodes = this.getters.allProducts || window.products;

            let images = nodes.map(el => el.field_trial_logo[0].url);

            context.commit('SET_TRIAL_LOGOS' ,images);

        },
        loadAppData: function(context) {
            // eslint-disable-next-line
            context.commit('SET_PAGE_DATA', mainJson);
            // eslint-disable-next-line
            context.commit('SET_PRODUCT_NAMES', productNames);
            // eslint-disable-next-line
            context.commit('SET_DISEASE_STATES', diseaseStates);
            // eslint-disable-next-line
            context.commit('SET_PHASES', phases); 
        },
        localStorageProducts: function() {
            var productStorage = window.localStorage.getItem('products'); 
            if(productStorage !== null)
            {
                return productStorage;
            }

            return false; 
        },
        localStorageDisclaimer: function() {
            var disclaimerStorage = window.localStorage.getItem('disclaimer'); 

            if(disclaimerStorage !== null)
            {
                return disclaimerStorage; 
            }

            return false; 
        }
    }
})
